import { ChannelPayloadFilter, SpyneTrait, ViewStream } from "spyne";
import { UtilTraits } from "traits/util-traits";

import AdaptSelectorTmpl from "../components/code-playground/example-templates/adapt-selector-examples.tmpl.html";
import AdaptSetActiveItemTmpl from "../components/code-playground/example-templates/adapt-set-active-item-examples.tmpl.html";

class SetActiveExample extends ViewStream {
  constructor(props = {}) {
    props.id = "set-active-item-example";
    props.template = AdaptSetActiveItemTmpl;
    super(props);
  }

  addActionListeners() {
    return [["CHANNEL_UI_CLICK_EVENT", "onClick", "nav a"]];
  }

  onClick(e) {
    const { pageId } = e.payload;

    // SET ACTIVE ITEM EXAMPLE
    this.props.el$("a").setActiveItem("selected", `.${pageId}`);
  }

  broadcastEvents() {
    return [["a", "click"]];
  }

  onRendered() {
    this.addChannel("CHANNEL_UI");
  }
}

class PageExample extends ViewStream {
  constructor(props = {}) {
    props.class = "page-example";
    props.data = props.data ?? { pageId: "home" };
    props.template = "<h4>PAGE: {{pageId}}</h4><p></p>";

    super(props);
  }
  addActionListeners() {
    return [["CHANNEL_UI_CLICK_EVENT", "disposeViewStream", "nav a"]];
  }

  onRendered() {
    this.addChannel("CHANNEL_UI");
    this.props.el$("p").el.innerText = `id: ${this.props.id$}`;
  }
}

class ExampleStage extends ViewStream {
  constructor(props = {}) {
    props.class = "example-stage";
    super(props);
  }
  addActionListeners() {
    return [["CHANNEL_UI_CLICK_EVENT", "onNavClicked", "nav a"]];
  }

  onNavClicked(e) {
    this.appendView(new PageExample({ data: e.payload }));
  }

  onRendered() {
    this.appendView(new SetActiveExample());
    this.appendView(new PageExample());

    this.addChannel("CHANNEL_UI");
  }
}

export class CodePlaygroundExamplesAdaptTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = "codePlaygroundAdapt$";

    super(context, traitPrefix);
  }

  static codePlaygroundAdapt$HelloWorld() {
    return "Hello World";
  }

  static codePlaygroundAdapt$SetActiveWithDispose() {
    this.appendView(new ExampleStage());

    //return `    ${ExampleStage}`

    return [
      {
        tabName: "StageView",
        scriptString: ExampleStage,
      },
      {
        tabName: "PageView",
        scriptString: PageExample,
      },
    ];
  }

  static codePlaygroundAdapt$SetActiveItem() {
    this.appendView(new SetActiveExample());

    //return `${SetActiveExample}`

    return [
      {
        tabName: "SetActiveItemView",
        scriptString: `     ${SetActiveExample}`,
      },
      {
        tabName: "SCSS",
        scriptString: `   #set-active-item-example{
    font-family: sans-serif;;
    nav {
      display: flex;
      justify-content:space-between;
      align-items: center;
      padding: 1rem 2rem;
      background: lightskyblue;
    }
  
    nav a {
      text-decoration: none;
      color: royalblue;
  
      &.selected{
        font-weight: 700;
        color: darkblue;
      }
    }
  }`,
      },
      {
        tabName: "Template",
        scriptString: `${UtilTraits.util$EscapeHTMLChars(AdaptSetActiveItemTmpl)}`,
      },
    ];
  }

  static codePlaygroundAdapt$SelectorExamples() {
    class AdaptTraits extends SpyneTrait {
      constructor(context) {
        let traitPrefix = "adapt$";
        super(context, traitPrefix);
      }

      static adapt$SetDefaults(props = this.props) {
        const cardsDefaultReducer = (acc, el) => {
          acc.push(el.classList.value);
          return acc;
        };
        this.props.defaultClassesArr = props
          .el$("li")
          .arr.reduce(cardsDefaultReducer, []);
      }

      static adapt$OnAdaptBtnClick(e) {
        const { method } = e.payload;
        const resetClass = (el, i) =>
          (el.classList.value = this.props.defaultClassesArr[i]);
        const methodHash = {
          add: () => this.props.el$("li").addClass("color"),
          remove: () => this.props.el$("li").removeClass("color"),
          toggle: () => this.props.el$("li").toggleClass("shape"),
          reset: () => this.props.el$("li").arr.forEach(resetClass),
        };
        methodHash[method]();
      }
    }

    class SelectorExamples extends ViewStream {
      constructor(props = {}) {
        props.id = "selector-examples";
        props.traits = AdaptTraits;
        props.template = AdaptSelectorTmpl;
        super(props);
      }

      addActionListeners(e) {
        const adaptBtnFilter = new ChannelPayloadFilter({ type: "adapt" });
        return [
          ["CHANNEL_UI_CLICK_EVENT", "adapt$OnAdaptBtnClick", adaptBtnFilter],
        ];
      }

      broadcastEvents() {
        return [["button", "click"]];
      }

      onRendered() {
        this.addChannel("CHANNEL_UI");
        this.adapt$SetDefaults();
      }
    }

    this.appendView(new SelectorExamples());

    return [
      {
        tabName: "SelectorExample",
        scriptString: `${SelectorExamples}`,
      },
      { tabName: "AdaptTraits", scriptString: `     ${AdaptTraits}` },
      {
        tabName: "SelectorTemplate",
        scriptString: `    ${UtilTraits.util$EscapeHTMLChars(AdaptSelectorTmpl)}`,
      },
      {
        tabName: "SCSS",
        scriptString: `     ${CodePlaygroundExamplesAdaptTraits.codePlaygroundAdapt$GetCSS()}`,
      },
    ];
  }

  static codePlaygroundAdapt$GetCSS() {
    return `#selector-examples{
          li{
            background-color: #fff;
            border: 1px solid #ddd;
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
            border-radius: 8px;
            padding: 2rem;
            text-align: center;
            min-width: 140px;
            &.shape::before {
                content: "\\2605";
                font-size: 4rem;
            }
            &.color {
              color: deepskyblue;
              &:not(.shape){
                background: deepskyblue;
              }
            }
          }
          .card-holder {
            position: relative;
            list-style-type: none;
            display: grid;
            grid-template-columns: repeat(5, 1fr);
            grid-gap:1rem;
          }
        }`;
  }
}
